import React from 'react';
import Navbar from './Navbar';

/* Navbar's AppBar already renders as <header>, and Navbar has its own
   i18n-aware skip-to-content link — no need for an extra wrapper. */
const Header = () => <Navbar />;

export default Header;
